<template>
  <owa-force-update-on-mounted>
    <header
      id="header"
      class="app-header"
      :style="componentStyle"
    >
      <div class="nav-products nav-products-full display-none tablet:display-block">
        <page-header-products />
      </div>

      <div
        id="nav-app"
        class="nav-app padding-y-md"
      >
        <div class="container display-flex flex-content-between flex-nowrap">
          <div
            class="display-flex"
            style="gap: var(--wa-space-2xs)"
          >
            <!-- Nav toggle -->
            <button
              class="flat swap-icons header-toggle-nav tablet:display-none"
              aria-label="Open Main Menu"
              data-balloon-pos="right"
              data-drawer="open app-drawer"
            >
              <font-awesome-icon
                :icon="$v7.regular.faBars"
                size="xl"
                class="initial-icon"
              />
              <font-awesome-icon
                :icon="$v7.solid.faHamburger"
                size="xl"
                class="hover-icon"
              />
            </button>

            <div class="header-nav display-none tablet:display-flex flex-items-center tablet:flex-items-stretch">
              <div
                class="wrap-links display-flex flex-items-center"
                style="gap: var(--spacing-md)"
              >
                <site-link
                  v-if="$account"
                  :to="routes.kits.location"
                  :class="mainLink(routes.kits)"
                  @click.native="$posthog.capture('main_navigation_link_click', { destination: 'kits' })"
                >
                  <span class="display-none laptop:display-inline">Your </span>Kits
                </site-link>
                <site-link
                  v-else
                  :to="routes.start.location"
                  :class="mainLink(routes.start)"
                  @click.native="$posthog.capture('main_navigation_link_click', { destination: 'start' })"
                >
                  Start
                </site-link>

                <site-link
                  :to="routes.search.location"
                  :class="mainLink(routes.search)"
                  title="Search icons"
                  @click.native="$posthog.capture('main_navigation_link_click', { destination: 'icon_search' })"
                >
                  <font-awesome-icon :icon="$v7.solid.faMagnifyingGlass" />
                  <span class="sr-only">Search Icons</span>
                </site-link>

                <site-link
                  :to="routes.icons.location"
                  :class="mainLink(routes.icons)"
                  @click.native="$posthog.capture('main_navigation_link_click', { destination: 'icons' })"
                >
                  Icons
                </site-link>

                <site-link
                  :to="routes.docs.location"
                  :class="mainLink(routes.docs)"
                  @click.native="$posthog.capture('main_navigation_link_click', { destination: 'docs' })"
                >
                  Docs
                </site-link>

                <site-link
                  :to="routes.plans.location"
                  :class="mainLink(routes.plans)"
                  @click.native="$posthog.capture('main_navigation_link_click', { destination: 'plans' })"
                >
                  Plans
                </site-link>

                <site-link
                  :to="routes.support.location"
                  :class="mainLink(routes.support)"
                  @click.native="$posthog.capture('main_navigation_link_click', { destination: 'support' })"
                >
                  Support
                </site-link>
              </div>
            </div>
          </div>

          <!-- Simple Logo -->
          <site-link
            :to="{ name: 'home' }"
            class="button flat tablet:display-none"
            aria-label="Font Awesome"
            @click.native="$posthog.capture('main_navigation_link_click', { destination: 'home' })"
          >
            <owa-logo-flag logo-size="2xl" />
          </site-link>

          <!-- Account -->
          <site-link
            v-if="$account"
            :to="routes.account.location"
            :class="['button flat', { active: routes.account.active }]"
            aria-label="Your Account"
            data-balloon-pos="left"
            @click.native="$posthog.capture('main_navigation_link_click', { destination: 'account' })"
          >
            <font-awesome-icon
              :icon="$v7.regular.faCircleUser"
              size="xl"
            />
            <span class="sr-only">Your Account</span>
          </site-link>
          <site-link
            v-else
            :to="routes.signIn.location"
            :class="['button flat swap-icons', { active: routes.signIn.active }]"
            aria-label="Sign In"
            data-balloon-pos="left"
            @click.native="$posthog.capture('main_navigation_link_click', { destination: 'sign_in' })"
          >
            <font-awesome-icon
              :icon="$v7.regular.faRightToBracket"
              size="xl"
              class="initial-icon"
            />
            <font-awesome-icon
              :icon="$v7.regular.faPersonToPortal"
              size="xl"
              class="hover-icon"
            />
            <span class="sr-only">Sign In</span>
          </site-link>
        </div>
      </div>

      <page-header-drawer />
    </header>
  </owa-force-update-on-mounted>
</template>

<script>
  import PageHeaderDrawer from './PageHeaderDrawer'
  import PageHeaderProducts from './PageHeaderProducts'
  import { PageHeaderRoutes } from './mixins'

  export default {
    name: 'PageHeader',

    components: {
      PageHeaderDrawer,
      PageHeaderProducts
    },

    mixins: [PageHeaderRoutes],

    props: {
      customStyle: {
        type: Object,
        default: () => {}
      },
      themeColor: {
        type: String
      }
    },

    computed: {
      componentStyle() {
        const style = { ...this.customStyle }
        if (this.themeColor) {
          style['--link-active-color'] = this.themeColor
        }
        return style
      }
    },

    methods: {
      mainLink(route) {
        return ['no-underline padding-y-xs padding-x-md', { active: route.active }]
      }
    }
  }
</script>
